// Application configuration constants
export const APP_CONFIG = {
  name: 'ArrasClientComplaints',
  version: '1.0.0',
  description: 'Secure contact form powered by React 19 and reCAPTCHA v3'
} as const;

// reCAPTCHA configuration
export const RECAPTCHA_CONFIG = {
  siteKey: 'YOUR_RECAPTCHA_SITE_KEY_HERE', // Replace with your actual site key
  actions: {
    CONTACT_FORM: 'contact_form_submit',
    LOGIN: 'login',
    REGISTRATION: 'registration'
  }
} as const;

// Form validation constants
export const VALIDATION_RULES = {
  name: {
    minLength: 2,
    maxLength: 100
  },
  email: {
    maxLength: 254
  },
  message: {
    minLength: 10,
    maxLength: 2000
  }
} as const;

// API endpoints (for future use)
export const API_ENDPOINTS = {
  CONTACT_FORM: '/api/contact',
  RECAPTCHA_VERIFY: '/api/recaptcha/verify'
} as const;
